import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import './plugins/outside'
import './plugins/vuetify'
import {i18n} from './plugins/i18n'
import * as VueGoogleMaps from "vue2-google-maps"
import {Drag, Drop} from 'vue-drag-drop'
import {helper} from './mixins/helper'

import 'material-design-icons/iconfont/material-icons.css'
import 'typeface-roboto/index.css'
import './assets/emoji-panel-apple-32.css'

import CryptManager from '@utils/cryptManager'

window.cryptManager = new CryptManager()

Vue.component('drag', Drag)
Vue.component('drop', Drop)

Vue.mixin(helper)
Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC8kSq2JMixyU8RllDGnsCYhNOClZPTr5c"
  }
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})
